import * as z from "zod/v4";

export const listMessagingConversations = {
  name: "listMessagingConversations" as const,
  input: z.object({
    limit: z.number().int().min(1).max(100).default(25),
    cursor: z.string().nullish(),
    filters: z
      .object({
        status: z.enum(["open", "closed", "snoozed", "escalated"]).nullish(),
        conversationType: z.enum(["pre_purchase", "post_purchase"]).nullish(),
        channel: z.enum(["imessage", "sms", "email"]).nullish(),
        search: z.string().nullish(),
      })
      .nullish(),
  }),
  output: z.object({
    conversations: z.array(
      z.object({
        id: z.string(),
        source: z.enum(["mobile_message", "marketing"]),
        conversationType: z.enum(["pre_purchase", "post_purchase"]),
        customerName: z.string().nullable(),
        customerPhone: z.string().nullable(),
        customerEmail: z.string().nullable(),
        lastMessagePreview: z.string().nullable(),
        lastMessageAt: z.string().nullable(),
        status: z.enum(["open", "closed", "snoozed"]),
        channel: z.enum(["imessage", "sms", "email"]),
        skillId: z.string().nullable(),
        aiDisabled: z.boolean(),
      }),
    ),
    nextCursor: z.string().nullable(),
  }),
};
